import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import abtest from './modules/abtest';
import analytics from './modules/analytics';
import cart from './modules/cart';
import category from './modules/category';
import features from './modules/features';
import i18n from './modules/i18n';
import layer from './modules/layer';
import navigationBar from './modules/navigationBar';
import notification from './modules/notification';
import orderForm from './modules/orderForm';
import pageActions from './modules/pageActions';
import request from './modules/request';
import routeNavigation from './modules/routeNavigation';
import script from './modules/script';
import search from './modules/search';
import searchEngine from './modules/searchEngine';
import seller from './modules/seller';
import sharedEnv from './modules/sharedEnv';
import accordion from './modules/ui/accordion';
import user from './modules/user';
import wishlist from './modules/wishlist';
export default (function () {
  return new Vuex.Store({
    actions: actions,
    getters: getters,
    modules: {
      i18n: i18n,
      cart: cart,
      user: user,
      layer: layer,
      script: script,
      seller: seller,
      search: search,
      request: request,
      category: category,
      orderForm: orderForm,
      features: features,
      wishlist: wishlist,
      analytics: analytics,
      sharedEnv: sharedEnv,
      pageActions: pageActions,
      searchEngine: searchEngine,
      navigationBar: navigationBar,
      routeNavigation: routeNavigation,
      accordion: accordion,
      notification: notification,
      abtest: abtest
    }
  });
});